<template>
  <div class="subscription-options">
    <div v-if="!subscribable" class="opacity-60">
      N/A
    </div>

    <div v-else-if="!readonly" class="select-wrapper">
      <select class="selected-sub-options pt-[0.4286rem] pr-[2.5rem] pb-[0.4286rem] pl-[1rem]"
        :id="selectId"
        :aria-label="label"
        :value="modelValue"
        @change="onChange"
      >
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>

    <div v-else class="font-semibold">
      {{ selectedOption?.label || '—' }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { TEST_SUBSCRIPTION_OPTIONS, DEFAULT_SUBSCRIPTION_OPTIONS } from '~~/shared/utils/contentTypes'

const props = withDefaults(
  defineProps<{
    modelValue: number
    readonly?: boolean
    subscribable?: boolean
    includeOnce?: boolean
    label?: string
    id?: string
  }>(),
  {
    readonly: false,
    subscribable: true,
    includeOnce: true,
    label: 'Subscription frequency'
  }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void
}>()

const selectId = computed(
  () => props.id || 'subscription-frequency-select'
)

const onChange = (event: Event) => {
  const value = Number((event.target as HTMLSelectElement).value)
  emit('update:modelValue', value)
}

const options = computed(() => {
  const list: { value: number; label: string }[] = []

  if (props.includeOnce) {
    list.push({ value: 0, label: 'Once' })
  }

  list.push(...DEFAULT_SUBSCRIPTION_OPTIONS)

  return list
})

const selectedOption = computed(() =>
  options.value.find(opt => opt.value === props.modelValue)
)
</script>
